// extracted by mini-css-extract-plugin
export default {"wrapper":"AddClientForm_wrapper__HTh83","controlWrapper":"AddClientForm_controlWrapper__exF5K","phoneInputWrapper":"AddClientForm_phoneInputWrapper__abUpV"};